import React from 'react';
import { useSelector } from 'react-redux';
import * as Styles from './ContractedProducts.styles';
import ProductList from '../ProductList';
import { Skeleton } from 'gatorcomponents';
import { HOSTING_PRODUCTS_BR, HOSTING_PRODUCTS_ES } from './ContractedProducts.enum';
import withErrorBoundary from '@/utils/errorBoundary';
import { isBRServer } from '@/utils/Validators/validation';

const ContractedProducts = ({ size }) => {
  const { productsList, productsLoading } = useSelector(state => state.preChat);
  const { domains: domainsList, hostings: hostingsList } = productsList;
  const hostingsArrayList = hostingsList || [];
  const filteredHostingsArrayList = hostingsArrayList.filter(hosting => (isBRServer ? HOSTING_PRODUCTS_BR.includes(hosting.package_id) : HOSTING_PRODUCTS_ES.includes(hosting.package_id)));
  const hostingsListLength = Object.keys(filteredHostingsArrayList).length;
  const domainsArrayList = domainsList || [];
  const domainsListLength = Object.keys(domainsArrayList).length;
  const isEmpty = (hostingsListLength === 0) && (domainsListLength === 0) ? 'true' : 'false';

  if (productsLoading) {
    return (
      <Styles.Card width={size} data-testid="contracted-products-skeleton-wrapper">
        <Styles.SkeletonElement firstParagraph>
          <Skeleton width="450px" height="32px" variant="headline" />
          <Styles.SkeletonParagraph>
            <Styles.SkeletonTexts>
              <Skeleton width="450px" height="150px" variant="textLine" />
              <Skeleton width="280px" height="150px" variant="textLine" />
            </Styles.SkeletonTexts>
            <Skeleton width="160px" height="32px" variant="button" />
          </Styles.SkeletonParagraph>
          <Styles.SkeletonParagraph>
            <Styles.SkeletonTexts>
              <Skeleton width="450px" height="150px" variant="textLine" />
              <Skeleton width="280px" height="150px" variant="textLine" />
            </Styles.SkeletonTexts>
            <Skeleton width="160px" height="32px" variant="button" />
          </Styles.SkeletonParagraph>
        </Styles.SkeletonElement>

        <Styles.SkeletonElement>
          <Skeleton width="450px" height="32px" variant="headline" />
          <Styles.SkeletonParagraph firstParagraph>
            <Styles.SkeletonTexts>
              <Skeleton width="450px" height="150px" variant="textLine" />
              <Skeleton width="280px" height="150px" variant="textLine" />
            </Styles.SkeletonTexts>
            <Skeleton width="160px" height="32px" variant="button" />
          </Styles.SkeletonParagraph>
          <Styles.SkeletonParagraph>
            <Styles.SkeletonTexts>
              <Skeleton width="450px" height="150px" variant="textLine" />
              <Skeleton width="280px" height="150px" variant="textLine" />
            </Styles.SkeletonTexts>
            <Skeleton width="160px" height="32px" variant="button" />
          </Styles.SkeletonParagraph>
        </Styles.SkeletonElement>
      </Styles.Card>
    );
  }

  return (
    <Styles.Card width={size} empty={isEmpty}>
      <ProductList variant="hosting" itens={filteredHostingsArrayList} loading={productsLoading} width={size} testId="hostingList" />

      <Styles.Divisor empty={isEmpty} width={size} />

      <ProductList variant="domain" itens={domainsList} loading={productsLoading} width={size} testId="domainList" />
    </Styles.Card>
  );
};

export default withErrorBoundary(ContractedProducts, 'ContractedProducts');
